import axios from "axios";
import { isNativeApp } from "../components/PayPalCheckout";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Auth header is injected by the global axios interceptor in AuthContext.jsx.

// Server-generated, branded PDF — works on desktop, mobile browsers and the Android app.
// lang: 'en' | 'hi' ('hi' is AI-translated on the server and cached per report).
//
// Android WebView note: a blob: URL never reaches Android's DownloadListener, which is why
// the in-app download used to fail intermittently. Inside the app we ask the server for a
// short-lived signed URL and navigate to it, so the native DownloadManager handles the save.
export async function downloadKundliPdf(reportId, name = "Kundli", lang = "en") {
  if (isNativeApp()) {
    const link = await axios.post(`${API}/kundli/report/${reportId}/pdf-link`, null, {
      params: { lang },
      withCredentials: true,
      timeout: 30000,
    });
    const url = process.env.REACT_APP_BACKEND_URL + link.data.path;
    window.location.href = url;
    return;
  }

  const res = await axios.get(`${API}/kundli/report/${reportId}/pdf`, {
    params: { lang },
    responseType: "blob",
    withCredentials: true,
    timeout: 180000,
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  const suffix = lang === "hi" ? "_Hindi" : "";
  a.download = `AstroFate_Kundli_${String(name || "Kundli").replace(/[^A-Za-z0-9_-]+/g, "_")}${suffix}.pdf`;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => { try { URL.revokeObjectURL(url); } catch (_) {} }, 30000);
}

// Emails the PDF to the logged-in user's account email.
export async function emailKundliPdf(reportId, lang = "en", to = "") {
  const res = await axios.post(`${API}/kundli/report/${reportId}/email`, null, {
    params: to ? { lang, to } : { lang },
    withCredentials: true,
    timeout: 180000,
  });
  return res.data;
}
